import { Validator,
    ExtendedFieldId,
    FieldContent,
    ExtendedErrorId,
    setCustomValidator,
    setMetadata,
    ErrorId,
    FieldId,
} from '@sheerid/jslib';

export const captainsCircleNumberValidator = () => {
    const captainsCircleNumberFieldId: ExtendedFieldId = 'captainsCircleNumber';
    setMetadata({ captainsCircleNumber: '' });
    const getCaptainsCircleNumberValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidCaptainsNumber: ExtendedErrorId = 'invalidCaptainsNumber';
        const tooShortError: ExtendedErrorId = 'shortCaptainsNumber';
        const missingCaptainsNumber: ExtendedErrorId = 'missingCaptainsNumber';
        const VALID_CCN_REGEXPS = [
            /((\d{9})+(\d{1}|\w{1}))|(^\d{9})/g,
        ];
        const matchedPatterns = VALID_CCN_REGEXPS.filter((regexp: RegExp) => regexp.test(value as string));

        if (value === '') {
            return missingCaptainsNumber;
        }

        if (value && (value as string).length < 9) {
            return tooShortError;
        }

        if (value && matchedPatterns.length < 1) {
            return invalidCaptainsNumber;
        }

        return;
    };
    setCustomValidator(captainsCircleNumberFieldId, getCaptainsCircleNumberValidationError);
};

export const stateValidator = () => {
    const stateFieldId: FieldId = 'state';
    setMetadata({ state: '' });
    const getStateValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ErrorId = 'invalidState';
        if (!value || value === '') {
            return invalidError;
        }
        return;
    };
    setCustomValidator(stateFieldId, getStateValidationError);
};

export const cityValidator = () => {
    const cityFieldId: FieldId = 'city';
    setMetadata({ city: '' });
    const getCityValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ErrorId = 'invalidCity';
        if (!value) {
            return invalidError;
        }
        return;
    };
    setCustomValidator(cityFieldId, getCityValidationError);
};

export const addressValidator = () => {
    const address1FieldId: FieldId = 'address1';
    setMetadata({ address1: '' });
    const getAddressValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ErrorId = 'invalidAddress';
        if (!value) {
            return invalidError;
        }
        return;
    };
    setCustomValidator(address1FieldId, getAddressValidationError);
};
